module.exports = __webpack_public_path__ + "d410d1b3d12c7ae7126cddd024787352.woff2";